import { AppParametersContext } from '@app/app/_context/AppParametersContext/AppParametersContext';
import { useContext } from 'react';

export function useAppParameters() {
    return useContext(AppParametersContext);
}
